import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom'
import Header from './Header'
import Example from './Example'
import Bottom from './Bottom'
import Wall from './Wall'
import cookie from 'react-cookies'
import ResetPassword from "./ResetPassword";
import MySchedules from "./MySchedules";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faCalendarDay } from '@fortawesome/free-solid-svg-icons'

library.add(faCalendarAlt, faCalendarDay)

class App extends Component {

    render() {
        return (
            <BrowserRouter>
                <div>
                    <Switch>
                        <Route path='/reset-password' component={ResetPassword}/>
                        <Route path='/wall' component={Wall}/>
                        <Route path='/my-schedules' component={MySchedules}/>
                    </Switch>
                </div>
            </BrowserRouter>
        )
    }
}

ReactDOM.render(<App/>, document.getElementById('app'))



// WEBPACK FOOTER //
// ./resources/js/components/App.js